import ActionButton from "./ActionButton";
import editIcon from "../../assets/edit.svg";

function EditButton(props) {
  return (
    <ActionButton
      {...props}
      icon={editIcon}
      className="btn-edit"
      title="Edit"
    />
  );
}

export default EditButton;